import { EventEmitter } from "@angular/core";

export class propertyChangedArguments {
    public propertyName: string;
    public object: BaseModel;
    constructor(name: string, sender: BaseModel) {
        this.propertyName = name;
        this.object = sender;
    }

}

export abstract class BaseModel
{

    public propertyChanged = new EventEmitter<propertyChangedArguments>();

  public replacer(key: string, value: any): any {
    console.log("replacer");
    if (key == "propertyChanged") return undefined;    
    return value;
  }

  //let toJSON: any = function () {
  //  var result = {};
  //  for (var x in this) {
  //    if (x !== "propertyChanged") {
  //      result[x] = this[x];
  //    }
  //  }
  //  return result;
  //};

  toJSON(): any {
    //console.log("tojson");

    var result: any = {};
    for (var x in this) {
      if (x !== "propertyChanged") {

        if (x.toString()[0] == "_") {
          let xp: string = x.toString().substring(1, x.toString().length );
          //console.log(x, xp);
          result[xp] = this[x];
        } else { 
          result[x] = this[x];
        }
      }
    }

    //console.log("tojson", result);

    return result;

  }

    assignChildren(): void {
        return;
    }
}
